import { Table } from 'semantic-ui-react'

import SortToggle from './SortToggle'

import './style.scss'

Table.SortToggle = SortToggle

export { Table }
